var _templateObject, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import styled from '@emotion/styled';
import MUISvgIcon, { svgIconClasses } from '@mui/material/SvgIcon';
import * as React from "react";
var SvgIcon = styled(MUISvgIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.", " {\n    width: ", ";\n    height: ", ";\n    color: ", ";\n    stroke-width: 1px;\n    vector-effect: non-scaling-stroke;\n  }\n"])), svgIconClasses.root, function (_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  return size && theme.size[size];
}, function (_ref2) {
  var size = _ref2.size,
    theme = _ref2.theme;
  return size && theme.size[size];
}, function (_ref3) {
  var color = _ref3.color,
    theme = _ref3.theme;
  return color && theme.color[color];
});
var SvgBridge = function SvgBridge(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.73 6.112c0-.693.56-1.252 1.253-1.252h20.035c.693 0 1.252.56 1.252 1.252v1.393a1.11 1.11 0 0 1-1.11 1.112 2.645 2.645 0 0 0-2.646 2.645v4.887c-.505 0-1.01.153-1.44.458-.705.486-1.57.795-2.317.795v-5.029a3.758 3.758 0 0 0-7.513 0v5.029c-.744 0-1.612-.31-2.313-.795a2.5 2.5 0 0 0-1.444-.458v-4.887a2.64 2.64 0 0 0-2.645-2.645A1.11 1.11 0 0 1 .73 7.505zm11.994 11.501c.88.607 1.957 1.021 3.033 1.021 1.053 0 2.168-.422 3.029-1.021a1.25 1.25 0 0 1 1.534.067 4.94 4.94 0 0 0 1.98.986 1.252 1.252 0 0 1-.567 2.438 7.5 7.5 0 0 1-2.278-.979c-1.135.61-2.406 1.014-3.698 1.014-1.248 0-2.371-.388-3.146-.74a13 13 0 0 1-.61-.301c-.177.094-.38.2-.611.301-.775.352-1.898.74-3.146.74-1.292 0-2.563-.403-3.698-1.01-.525.329-1.319.755-2.278.978a1.252 1.252 0 0 1-.567-2.437 4.94 4.94 0 0 0 1.98-.987 1.26 1.26 0 0 1 1.534-.066c.865.595 1.976 1.017 3.029 1.017 1.076 0 2.152-.415 3.033-1.021a1.25 1.25 0 0 1 1.447 0"
  }))));
};
export default SvgBridge;